module.exports = __webpack_public_path__ + "img/magento-vs-woocommerce-showdown.36fdaac1.webp";